import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button } from "@mui/material"

interface Props
{
    open: boolean
    title: string
    text: string
    onDeleteConfirmed: () => void
    onDeleteCanceled: () => void
}

export default function CommentDeleteDialog({ open, title, text, onDeleteConfirmed, onDeleteCanceled }: Props)
{
    const handleOnDelete = () =>
    {
        onDeleteConfirmed()
    }

    const handleOnCancel = () =>
    {
        onDeleteCanceled()
    }

    return <Dialog
        open={open}
        aria-labelledby="delete-dialog-title"
        aria-describedby="delete-dialog-description"
    >
        <DialogTitle id="delete-dialog-title">
            {title}
        </DialogTitle>
        <DialogContent>
            <DialogContentText id="delete-dialog-description">
                {text}
            </DialogContentText>
        </DialogContent>
        <DialogActions>
            <Button onClick={handleOnDelete}>Delete</Button>
            <Button onClick={handleOnCancel} autoFocus>Cancel</Button>
        </DialogActions>
    </Dialog>
}